import { apiClient } from './api-client';
import type { MeProfile, UpdateMyProfilePayload } from '@/types/profile.types';

/**
 * User Profile P1 — the tenant-staff self-service account resource.
 *
 * Every call is SELF-scoped: the routes carry no user id, the server takes the
 * subject from the access token. This service therefore has no `id` parameter
 * anywhere, by design.
 */
export const profileService = {
  getMe: (): Promise<MeProfile> => apiClient.get<MeProfile>('/auth/me').then((r) => r.data),

  updateMe: (payload: UpdateMyProfilePayload): Promise<MeProfile> =>
    apiClient.patch<MeProfile>('/auth/me', payload).then((r) => r.data),

  uploadPhoto: (file: File): Promise<MeProfile> => {
    const form = new FormData();
    form.append('photo', file);
    return apiClient
      .post<MeProfile>('/auth/me/profile-photo', form, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      .then((r) => r.data);
  },

  deletePhoto: (): Promise<MeProfile> =>
    apiClient.delete<MeProfile>('/auth/me/profile-photo').then((r) => r.data),
};
